/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Copy_LinkInputs */

const en_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Link`)
};

const es_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar enlace`)
};

const fr_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le lien`)
};

const de_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopieren`)
};

const ja_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクをコピー`)
};

const zh_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制链接`)
};

const ar_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخ الرابط`)
};

const id_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin Tautan`)
};

const it_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia Link`)
};

const ru_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копировать ссылку`)
};

const pt_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar Link`)
};

const ko_action_copy_link = /** @type {(inputs: Action_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`링크 복사`)
};

/**
* | output |
* | --- |
* | "Copy Link" |
*
* @param {Action_Copy_LinkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_copy_link = /** @type {((inputs?: Action_Copy_LinkInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Copy_LinkInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_copy_link(inputs)
	if (locale === "es") return es_action_copy_link(inputs)
	if (locale === "fr") return fr_action_copy_link(inputs)
	if (locale === "de") return de_action_copy_link(inputs)
	if (locale === "ja") return ja_action_copy_link(inputs)
	if (locale === "zh") return zh_action_copy_link(inputs)
	if (locale === "ar") return ar_action_copy_link(inputs)
	if (locale === "id") return id_action_copy_link(inputs)
	if (locale === "it") return it_action_copy_link(inputs)
	if (locale === "ru") return ru_action_copy_link(inputs)
	if (locale === "pt") return pt_action_copy_link(inputs)
	return ko_action_copy_link(inputs)
});